/**
 * Types of banners that may be displayed if
 * showInformationBanner === True
 */
export enum BannerStatus {
  INCIDENT = 'INCIDENT',
  RESOLVED = 'RESOLVED',
  INFO = 'INFO',
}
